import { useQuery } from "@tanstack/react-query";

import { queryClient } from "../../queryClient.ts";
import { spbTransferAPI } from "../spbTransferAPI.ts";

export const CHECK_ACTIVE_SBP_TRANSFER_QUERY_KEY = "active-spb-transfer";

export const useCheckActiveSbpTransferQuery = () => {
  return useQuery ({
    queryKey: [CHECK_ACTIVE_SBP_TRANSFER_QUERY_KEY],
    queryFn: () => spbTransferAPI.checkActiveTransfer(),
    select: (data) => {
      const time = data.isTrancheActive === false ? 15 * 60 * 1000 : 0; // 15мин или 0мин

      queryClient.setQueryDefaults([CHECK_ACTIVE_SBP_TRANSFER_QUERY_KEY], {
        staleTime: time,
        gcTime: time,
      });

      return data;
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
